import { Box, styled, Avatar, alpha } from '@mui/material';

export const FamilyMemberListItemStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '60px',
  alignItems: 'center',
  minWidth: '60px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  paddingTop: theme.spacing(3),
  marginLeft: theme.spacing(1),
})) as typeof Box;

export const FamilyMemberCircleStyled = styled(Avatar)(({ theme }) => ({
  width: 36,
  height: 36,
  padding: theme.spacing(1),
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
}));
